import { connect } from "react-redux";
import moment from "moment";
import React from "react";

import {
  _30_MIN_INDIVIDUAL_90832,
  _45_MIN_INDIVIDUAL_90834,
  _60_MIN_INDIVIDUAL_90837,
  allottedTimeFactory,
  BEHAVIORAL,
  BEHAVIORAL_INTAKE,
  DIAGNOSTIC_INTERVIEW_90792,
  ESTABLISHED_PATIENT_OFFICE_OR_OTHER_OUTPATIENT_SERVICES_99215,
  FAMILY_THERAPY_90847,
  FAMILY_THERAPY_WO_PATIENT_90846,
  MEDICATION_MGMT_99212,
  MEDICATION_MGMT_99213,
  MEDICATION_MGMT_99214,
  OFFICE_OR_OTHER_OUTPATIENT_VISIT_W_NEW_PATIENT_99204,
  OFFICE_OR_OTHER_OUTPATIENT_VISIT_W_NEW_PATIENT_99205,
  PRESCRIBE,
} from "@/components/Provider/ScheduleAvailability/constants";
import CardSecondary from "@/components/UI/Card/CardSecondary";
import { eventTypeDisplayNameFactory } from "@/components/Provider/ScheduleAvailability/ActiveScheduleDetails";
import InputError from "@/components/UI/InputError";
import { Select } from "@/components/UI/StyledInput";

import { serviceLocationOptions } from "../../../components/Provider/PatientView/MemberProfile/constants";

export const GUIDED_SESSION_CPT_OPTIONS = [
  {
    display: `30 Minute Individual (90832) (${allottedTimeFactory(
      _30_MIN_INDIVIDUAL_90832,
    )} minutes)`,
    provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
    value: _30_MIN_INDIVIDUAL_90832,
  },
  {
    display: `45 Minute Individual (90834) (${allottedTimeFactory(
      _45_MIN_INDIVIDUAL_90834,
    )} minutes)`,
    provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
    value: _45_MIN_INDIVIDUAL_90834,
  },
  {
    display: `60 Minute Individual (90837) (${allottedTimeFactory(
      _60_MIN_INDIVIDUAL_90837,
    )} minutes)`,
    provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
    value: _60_MIN_INDIVIDUAL_90837,
  },
  {
    display: `Family Therapy w/ Patient (90847) (${allottedTimeFactory(
      FAMILY_THERAPY_90847,
    )} minutes)`,
    provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
    value: FAMILY_THERAPY_90847,
  },
  {
    display: `Family Therapy w/o Patient (90846) (${allottedTimeFactory(
      FAMILY_THERAPY_WO_PATIENT_90846,
    )} minutes)`,
    provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
    value: FAMILY_THERAPY_WO_PATIENT_90846,
  },
  {
    display: `Office or Other Outpatient Visit w/ New Patient (99204) (${allottedTimeFactory(
      OFFICE_OR_OTHER_OUTPATIENT_VISIT_W_NEW_PATIENT_99204,
    )} minutes)`,
    provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
    value: OFFICE_OR_OTHER_OUTPATIENT_VISIT_W_NEW_PATIENT_99204,
  },
  {
    display: `Office or Other Outpatient Visit w/ New Patient (99205) (${allottedTimeFactory(
      OFFICE_OR_OTHER_OUTPATIENT_VISIT_W_NEW_PATIENT_99205,
    )} minutes)`,
    provider_types: [BEHAVIORAL],
    value: OFFICE_OR_OTHER_OUTPATIENT_VISIT_W_NEW_PATIENT_99205,
  },
  {
    display: `Diagnostic Interview (90792) (${allottedTimeFactory(
      DIAGNOSTIC_INTERVIEW_90792,
    )} minutes)`,
    provider_types: [PRESCRIBE],
    value: DIAGNOSTIC_INTERVIEW_90792,
  },
  {
    display: `Medication Management (99212) (${allottedTimeFactory(
      MEDICATION_MGMT_99212,
    )} minutes)`,
    provider_types: [PRESCRIBE],
    value: MEDICATION_MGMT_99212,
  },
  {
    display: `Medication Management (99213) (${allottedTimeFactory(
      MEDICATION_MGMT_99213,
    )} minutes)`,
    provider_types: [PRESCRIBE],
    value: MEDICATION_MGMT_99213,
  },
  {
    display: `Medication Management (99214) (${allottedTimeFactory(
      MEDICATION_MGMT_99214,
    )} minutes)`,
    provider_types: [PRESCRIBE],
    value: MEDICATION_MGMT_99214,
  },
  {
    display: `${eventTypeDisplayNameFactory(
      ESTABLISHED_PATIENT_OFFICE_OR_OTHER_OUTPATIENT_SERVICES_99215,
    )}`,
    provider_types: [PRESCRIBE],
    value: ESTABLISHED_PATIENT_OFFICE_OR_OTHER_OUTPATIENT_SERVICES_99215,
  },
];

const NotesDuration = (props) => {
  const { editable, editHandler, errors, note, profileView } = props;

  const handleSelection = async (e) => {
    if (!editable) {
      return;
    }
    const newSessionTo = moment(note.session_from, "HH:mm")
      .add(allottedTimeFactory(e.target.value), "minutes")
      .format("HH:mm");

    const newNoteTitle =
      note.title.split(" - ")[0] +
      ` - (${moment(note["session_from"], "HH:mm").format("hh:mm A")}-${moment(
        newSessionTo,
        "HH:mm",
      ).format("hh:mm A")})`;

    editHandler("call_type", e.target.value, false);
    editHandler("session_to", newSessionTo, false);
    editHandler("title", newNoteTitle, false);
    editHandler("call_name", eventTypeDisplayNameFactory(e.target.value), false);
  };

  const handleServiceLocationSelection = (e) => {
    editHandler("service_location", e.target.value, false);
  };

  const options = props.profile?.provider_type
    ? GUIDED_SESSION_CPT_OPTIONS.filter((option) =>
        option.provider_types.includes(props.profile.provider_type),
      )
    : [];

  const isPrescriber = props.profile?.provider_type === PRESCRIBE;
  const innerContentTitle = `Call Duration${isPrescriber ? " and Location" : ""}`;

  let innerContent = (
    <>
      <div>
        <div className="clr-sec px-3 py-3 tw:font-bold">{innerContentTitle}</div>
      </div>
      <div className="row px-4">
        {editable && (
          <>
            <div className="col-lg-7 col-12 pb-3">
              <span className="font-weight-bold">Select CPT Code</span>
              <Select
                changeHandler={handleSelection}
                name="call_type"
                options={options}
                testId="NotesDuration_cptCode"
                value={note["call_type"]}
              />

              {errors["call_type"] ? (
                <InputError classes="custom-error">{errors["call_type"]}</InputError>
              ) : (
                ""
              )}
            </div>

            {isPrescriber && (
              <div className="col-lg-7 col-12 pb-3">
                <span className="font-weight-bold">Select Service Location</span>
                <Select
                  changeHandler={handleServiceLocationSelection}
                  name="service_location"
                  options={serviceLocationOptions}
                  value={note.service_location}
                />
                {errors.service_location ? (
                  <InputError classes="custom-error">{errors.service_location}</InputError>
                ) : (
                  ""
                )}
              </div>
            )}
          </>
        )}

        {!editable && (
          <div className="fs-12">
            <div className="col-12 mb-1">
              <div className="tw:font-bold">CPT Code</div>
              <div>{eventTypeDisplayNameFactory(note["call_type"])}</div>
            </div>
            {note.service_location && (
              <div className="col-12 mb-1">
                <div className="tw:font-bold">Service Location</div>
                <div>{note.service_location}</div>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
  let content;

  if (!profileView) {
    content = (
      <CardSecondary className="mx-0 px-3 py-3 my-3 max-width" style={{ minHeight: 200 }}>
        {innerContent}
      </CardSecondary>
    );
  } else {
    content = (
      <div className="border-top-note border-right-note" style={{ minHeight: 150 }}>
        {innerContent}
      </div>
    );
  }

  return <>{content}</>;
};

const mapStateToProps = (state) => {
  return {
    profile: state.auth.profile,
  };
};

export default connect(mapStateToProps)(NotesDuration);
